"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundToNearest = exports.PositiveInt = exports.PositiveIntBounds = void 0;
const effect_1 = require("effect");
const NAMESPACE = 'Utils.Number';
exports.PositiveIntBounds = { min: 1 };
exports.PositiveInt = effect_1.Schema.Int.pipe(effect_1.Schema.positive()).annotations({
    identifier: `${NAMESPACE}.PositiveInt`,
});
const roundToNearest = (value, nearest) => Math.round(value / nearest) * nearest;
exports.roundToNearest = roundToNearest;
//# sourceMappingURL=number.js.map